import { getStore } from 'app/state/storeRegistry'
import { getMapConfigForAgent } from '../state/builderSliceUtils'
import { BuilderGenAIEnvironment } from '../types'
import { createAgentV0 } from '../api/genAi'
import { sendMetricEvent } from 'features/metrics/model/metricsMutations'
import { MetricEventType } from 'features/metrics/api/metrics'
import { getEnrichedDatasets } from '../state/keplerGlSlice'
import { FeatureFlag } from 'app/ui/useFeatureFlag'
import { getFeatureFlag } from 'features/common/state/commonSlice'
import { builderLayersSelector } from '../state/builderSlice'

/** @deprecated Currently unused under AI API v1, but kept for v0. */
export async function updateAIMapAgent(environment: BuilderGenAIEnvironment) {
  const store = getStore()
  const map = store.getState().maps.currentMap
  const mapId = map?.id || ''
  const datasets = getEnrichedDatasets(store.getState())
  const layers = builderLayersSelector(store.getState())
  const connections = store.getState().connections.myConnections
  const mapConfig = getMapConfigForAgent({ map, datasets, layers, connections })
  const userContext = store.getState().builder.aiSettings.mapContext
  const isGenAIV1 = getFeatureFlag(store.getState(), FeatureFlag.GenAIV1)

  if (!mapConfig || isGenAIV1) return

  const { agent, createdAt } = await createAgentV0({ mapId, mapConfig, userContext, environment })

  sendMetricEvent(MetricEventType.CARTOAIAgentCreated, {
    mapId: map.id,
    assistantId: agent,
    timestamp: createdAt,
    environment
  })
}
